export default __webpack_public_path__ + "static/media/keto_breath@2x.c41f4ce3.jpg";